/**
 * Created by wjjn3481 on 2017/8/10.
 */

export default {
    methods: {
        opIdHandler () {
            // 兼容统一登录的反馈
            let res = this.$route.query.opid || this.$route.query.unity
            res = res ? JSON.parse(res) : {}
            if (Object.keys(res).length) {
                if (res.status === true || res.status === 'true') {
                    if (res.result && res.result.project.length > 1) {  // 多个项目
                        this.trans(res.result.project)
                    }
                } else {
                    this.$store.commit('MESSAGE_ERROR', res.desc)
                }
            }
        }
    },
    created () {
        this.opIdHandler()
    }
}


// WEBPACK FOOTER //
// ./src/views/login/openIDhandlerMixin.js